'use strict';

import React, {useCallback, useEffect, useState} from 'react';
import {h, Fragment} from 'preact';
import ReactDOM from 'react-dom';
import Mix from '../../helpers/mix';

global = typeof global !== 'undefined' ? global : window;

if (typeof window !== 'undefined') {
    window.preloadedMenuHtml = $('#js-app-menu').html();
}

function TechMenu(props) {
    const {tech} = props;

    const detailHoverOn = useCallback(() => {
        window.detailHover = true;
    }, []);

    const detailHoverOff = useCallback(() => {
        window.detailHover = false;
    }, []);

    return (
        <li className='mega-unit mega-hdr' data-search={tech.name}>
            <a href={tech.url} className='mega-hdr-link' onMouseOver={props.setCurrent.bind(this, tech.id)}>
                {tech.name}
            </a>

            <div
                className='sub-container mega sub-menu js-sidenav-parent'
                style={{display: props.current === tech.id ? 'block' : 'none'}}>
                <ul className='sub sub-menu_list' onMouseOver={detailHoverOn} onMouseOut={detailHoverOff}>
                    <li className='mega-unit sub-menu_col js-sidenav-results-column' style={{display: 'none'}}>
                        <ul></ul>
                    </li>

                    {props.current === tech.id &&
                        tech.details.map(detail => <DetailMenu {...{tech, detail}} key={detail.id} />)}

                    {tech.hasMore && (
                        <div className='sub-menu_item sub-menu_holder'>
                            {/*Смотреть еще*/}
                            <a href={tech.url} className='sub-menu_more'>
                                {trans('menu.see_more')}
                            </a>
                        </div>
                    )}
                </ul>

                {tech.details && tech.details.length <= 24 && tech.favorites && tech.favorites.length > 0 && (
                    <div className='sub-menu_favorites'>
                        <div className='sub-menu_favtitle'>
                            {/*Избранные товары*/}
                            <h3>{trans('menu.favorites')}</h3>
                            <div className='sub-menu_divider'></div>
                        </div>

                        <div className='wrap_items'>
                            {tech.favorites.map(product => '')}

                            {/*@foreach($tech->favorites as $product)
                    @include('sections.product-short', ['product' => $product->good])
                    @endforeach*/}
                        </div>
                    </div>
                )}
            </div>
        </li>
    );
}

function DetailMenu(props) {
    const {tech, detail} = props;

    return (
        <li className={`mega-unit sub-menu_item js-sidenav-column js-sidenav-tech-${tech.id}`}>
            <a href={detail.url} className='sub-menu_link'>
                <div className='dc-mega-img sub-menu_img'>
                    <img data-original={Mix.img(detail.icon)} className='lazy' />
                </div>

                {detail.name}
            </a>
        </li>
    );
}

export default function Menu(props) {
    const preloaded = typeof window !== 'undefined' ? null : props.context.pageData.groups;

    const [groups, setGroups] = useState(preloaded || []);
    const [currentGroup, setCurrentGroup] = useState(null);
    const [currentTech, setCurrentTech] = useState(null);

    useEffect(() => {
        if (!preloaded) {
            $.get(
                global.config.lang === 'ru' ? '/theme/menu/' : '/ua/theme/menu/',
                response => {
                    if (!response) {
                        return;
                    }

                    setGroups(response);
                    setTimeout(initMenu, 1);
                },
                'json'
            );
        }

        setTimeout(initMenu, 1);
    }, [setGroups]);

    const selectGroup = useCallback(
        id => {
            if (window.selectGroupTimer) {
                clearTimeout(window.selectGroupTimer);
            }

            window.selectGroupTimer = setTimeout(() => {
                if (window.techHover || window.detailHover) {
                    return;
                }

                setCurrentGroup(id);
                setCurrentTech(null);
            }, 300);
        },
        [global.selectGroupTimer, global.techHover, global.detailHover]
    );

    const selectTech = useCallback(
        id => {
            if (window.selectTechTimer) {
                clearTimeout(window.selectTechTimer);
            }

            window.selectTechTimer = setTimeout(() => {
                if (window.detailHover) {
                    return;
                }

                setCurrentTech(id);
            }, 300);
        },
        [global.selectTechTimer, global.detailHover]
    );

    const techHoverOn = useCallback(() => {
        window.techHover = true;
    }, []);

    const techHoverOff = useCallback(() => {
        window.techHover = false;
    }, []);

    const close = useCallback(() => {
        if (window.selectGroupTimer) {
            clearTimeout(window.selectGroupTimer);
        }

        if (window.selectTechTimer) {
            clearTimeout(window.selectTechTimer);
        }

        setCurrentTech(null);
        setCurrentGroup(null);
    }, []);

    if (groups.length < 1) {
        return <div dangerouslySetInnerHTML={{__html: window.preloadedMenuHtml}}></div>;
    }

    return (
        <div className='wrap_list'>
            <ul className='mega-menu' id='mega-menu' onMouseLeave={close}>
                {groups.map(group => (
                    <li className='dc-mega-li' key={group.id}>
                        <a href='#' className='dc-mega' onMouseOver={selectGroup.bind(this, group.id)}>
                            <div className='dc-mega-img mega-menu_img'>
                                <img data-original={Mix.img(group.icon)} className='lazy' />
                            </div>
                            <span className='dc-mega-txt'>{group.title}</span>
                            <span className='dc-mega-icon'></span>
                        </a>

                        <div
                            className='sub-container mega'
                            style={{display: currentGroup === group.id ? 'block' : 'none'}}>
                            <ul
                                className={`sub level_2 js-sidenav-group-${group.id}`}
                                onMouseOver={techHoverOn}
                                onMouseOut={techHoverOff}>
                                {currentGroup === group.id &&
                                    group.techs.map(tech => (
                                        <TechMenu
                                            {...{tech}}
                                            key={tech.id}
                                            current={currentTech}
                                            setCurrent={selectTech}
                                        />
                                    ))}
                            </ul>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}

const initMenu = () => {
    let isNavOverlayActive = false;
    let menuOverlayTimeout;

    const $menu = $('.mega-menu');

    if ($menu.length < 1) {
        return;
    }

    const megaMenuHeight = $menu.height();

    $(document).on('mouseover', '#mega-menu .dc-mega-li', function () {
        $(this).find('.sub-container:first').css({minHeight: megaMenuHeight});
    });

    $(document).on('mouseover', '#mega-menu .mega-hdr', function () {
        $(this).find('.sub-container:first').css({minHeight: megaMenuHeight});
    });

    $menu.mouseenter(function () {
        menuOverlayTimeout = setTimeout(function () {
            $('.calculator_top').removeClass('active');
            $('.dialog_calc').hide();
            $('#navOverlay').addClass('active');
            $('.left_catalog').css({'z-index': '100000', position: 'relative'});

            isNavOverlayActive = true;
        }, 250);
    });

    $menu.mouseleave(function () {
        if (menuOverlayTimeout) {
            clearTimeout(menuOverlayTimeout);
        }

        isNavOverlayActive = false;

        $('#navOverlay').removeClass('active');
        $('.left_catalog').css({position: 'static'});
        $('.level_2').css('margin-top', 0);
    });

    var menuOffsetTop = $menu.offset().top;

    $(window).scroll(function () {
        if (!isNavOverlayActive) {
            return;
        }

        var secondMenuLvl = $('.dc-mega-li .level_2'),
            thirdMenuLvl = $('.mega-unit .sub'),
            scrollTop = $(window).scrollTop(),
            scrollDistance = menuOffsetTop - scrollTop,
            menuHeight = $('.dc-mega-li .sub-container').height(),
            secondLvlMaxScrollDistance = menuOffsetTop + menuHeight - secondMenuLvl.height(),
            thirdLvlMaxScrollDistance = menuOffsetTop + menuHeight - thirdMenuLvl.height();

        var secondLvlPosition;

        if (scrollDistance < 0 && scrollTop < secondLvlMaxScrollDistance) {
            secondLvlPosition = Math.abs(scrollDistance);
        } else if (scrollDistance >= 0) {
            secondLvlPosition = 0;
        } else if (scrollTop >= secondLvlMaxScrollDistance) {
            secondLvlPosition = menuHeight - secondMenuLvl.height();
        }

        secondMenuLvl.css('margin-top', secondLvlPosition);

        var thirdLvlPosition;

        if (scrollDistance < 0 && scrollTop < thirdLvlMaxScrollDistance) {
            thirdLvlPosition = Math.abs(scrollDistance);
        } else if (scrollDistance >= 0) {
            thirdLvlPosition = 0;
        } else if (scrollTop >= thirdLvlMaxScrollDistance) {
            thirdLvlPosition = menuHeight - thirdMenuLvl.height();
        }

        thirdMenuLvl.css('margin-top', thirdLvlPosition);
    });
};

if (typeof window !== 'undefined') {
    const target = document.querySelector('#js-app-menu');

    if (target) {
        ReactDOM.render(<Menu />, target);
    }
}
